<template>
    <form @submit.prevent="submit">
        <div class="flex flex-wrap">
            <div class="w-full lg:w-1/2 px-2">
                <card>
                    <template slot="header">
                        Overview
                    </template>

                    <div class="p-8 flex flex-wrap">
                        <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-4 w-full"
                                    label="Name"/>
                        <text-input v-model="form.description" :error="form.errors.description" class="pr-6 pb-4 w-full"
                                    label="Description"/>
                    </div>
                </card>
            </div>

            <div class="w-full lg:w-1/2 px-2">
                <card>
                    <template slot="header">
                        Fields
                    </template>

                    <draggable v-model="form.fields">
                        <card-list-item v-for="(field, idx) in form.fields" :text="field" :key="idx"
                                        class="cursor-move">
                            {{ field }}

                            <button type="button" @click="removeField(idx)"
                                    class="px-1 py-1 ml-auto rounded bg-red-600 text-white text-sm leading-4 font-semibold whitespace-nowrap hover:bg-red-800 focus:bg-red-800"
                                    tabindex="-1">
                                <icon name="close" class="w-3 h-3 fill-white"/>
                            </button>
                        </card-list-item>
                    </draggable>

                    <card-list-item v-if="form.fields.length === 0">
                        No fields found.
                    </card-list-item>

                    <template slot="footer">
                        <select-input v-model="newField">
                            <optgroup v-for="group in fieldGroups" :label="group.label" :key="group.label">
                                <option v-for="field in group.fields" :key="field" v-text="field"></option>
                            </optgroup>
                        </select-input>

                        <button type="button" @click="addField" :disabled="newField === null"
                                class="btn-indigo ml-auto">
                            Add Field
                        </button>
                    </template>
                </card>
            </div>

            <div class="w-full flex items-center px-2">
                <button v-if="id != null" @click="destroy" class="btn-red" tabindex="-1" type="button">Delete Custom
                    Report
                </button>
                <loading-button v-if="id == null" :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                    Create Custom Report
                </loading-button>
                <loading-button v-else :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Custom
                    Report
                </loading-button>
            </div>
        </div>
    </form>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Card from '@/Shared/Card/Card'
import CardListItem from '@/Shared/Card/CardListItem'
import Icon from '@/Shared/Icon'
import draggable from 'vuedraggable'

export default {
    components: {
        Card,
        CardListItem,
        TextInput,
        SelectInput,
        LoadingButton,
        Icon,
        draggable,
    },
    props: {
        fieldGroups: Array,
        id: Number,
        name: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        fields: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            newField: null,
            form: this.$inertia.form({
                name: this.name,
                description: this.description,
                fields: this.fields,
            }),
        }
    },
    methods: {
        addField() {
            if (this.newField === null) {
                return
            }

            this.form.fields.push(this.newField)
            this.newField = null
        },
        removeField(idx) {
            this.form.fields.splice(idx, 1)
        },
        submit() {
            if (this.id == null) {
                this.form.post(this.route('custom-reports.store'))
            } else {
                this.form.put(this.route('custom-reports.update', this.id))
            }
        },
        destroy() {
            if (confirm('Are you sure you want to delete this custom report?')) {
                this.$inertia.delete(this.route('custom-reports.destroy', [this.id]))
            }
        },
    },
}
</script>
